import { render, staticRenderFns } from "./RealTimePolicy.vue?vue&type=template&id=6caf3b5e&"
import script from "./RealTimePolicy.vue?vue&type=script&lang=js&"
export * from "./RealTimePolicy.vue?vue&type=script&lang=js&"
import style0 from "./RealTimePolicy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports